import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { AUDIO } from '../../types/CallMediaTypes';
export const getZoomRecordingFile = ({
  engagementId,
  externalAccountId,
  mediaType = AUDIO
}) => {
  return http.get(`zoom/v1/recordings/file?engagementId=${engagementId}&fileType=${mediaType}&portalId=${PortalIdParser.get()}&accountId=${externalAccountId}`);
};